import { render, staticRenderFns } from "./PropertyTypes.vue?vue&type=template&id=11f895c7&scoped=true&"
import script from "./PropertyTypes.vue?vue&type=script&lang=js&"
export * from "./PropertyTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f895c7",
  null
  
)

export default component.exports